import { Request } from 'Core/Common/Request';
import { P } from 'Core/Common/Promise';
import {
	ISupportTicketsRequest,
	ISupportTicketsResult,
	IUpdateSupportTicketRequest,
	ISupportInfoResult,
	ISupportTicketScreenshotRequest,
	ISupportTicketScreenshot
} from './Models/SupportTicketModels';

export class SupportTicketsStore {
	static GetTickets(params: ISupportTicketsRequest): P.Promise<ISupportTicketsResult> {
		const deferred = P.defer<ISupportTicketsResult>();
		Request
			.For('/api/SupportApi/GetTickets')
			.Post(params)
			.then(data => deferred.resolve(data))
			.fail(error => deferred.reject(error));
		return deferred.promise();
	}

	static GetSupportInfo(dataBaseName: string): P.Promise<ISupportInfoResult> {
		const deferred = P.defer<ISupportInfoResult>();
		Request
			.For(`/api/SupportApi/GetSupportInfo?DataBaseName=${encodeURIComponent(dataBaseName)}`)
			.Get()
			.then((data: any) => {
				if (data.IsSuccessfull) {
					deferred.resolve(data.ResultObject);
				} else {
					deferred.reject({ message: data.ErrorMessage });
				}
			})
			.fail(error => deferred.reject(error));
		return deferred.promise();
	}

	static GetTicketScreenshot(params: ISupportTicketScreenshotRequest): P.Promise<ISupportTicketScreenshot> {
		const deferred = P.defer<ISupportTicketScreenshot>();
		Request
			.For('/api/SupportApi/GetTicketScreenshot')
			.Post(params)
			.then(data => deferred.resolve(data))
			.fail(error => deferred.reject(error));
		return deferred.promise();
	}

	static UpdateTicket(params: IUpdateSupportTicketRequest): P.Promise<any> {
		const deferred = P.defer();
		Request
			.For('/api/SupportApi/UpdateTicket')
			.Post(params)
			.then(data => deferred.resolve(data))
			.fail(error => deferred.reject(error));
		return deferred.promise();
	}
}
